export const primaryFont =
  "'Livvic', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif";

export const codeFont = "Consolas, monospace";
